/** Block competitor / aggregator URLs from ever rendering in the UI. */
const BLOCKED_HOSTS = new Set([
  'sarkariresult.com',
  'sarkariresult.in',
  'sarkariresults.com',
]);

export function isSafeExternalUrl(url?: string | null): url is string {
  if (!url || typeof url !== 'string') return false;
  try {
    const host = new URL(url).hostname.replace(/^www\./i, '').toLowerCase();
    return !BLOCKED_HOSTS.has(host);
  } catch {
    return false;
  }
}

export function safeExternalUrl(url?: string | null): string | undefined {
  return isSafeExternalUrl(url) ? url : undefined;
}
